// src/components/TimerDisplay.js

import React from 'react';
import PropTypes from 'prop-types';

function TimerDisplay({ remainingTime = 0, color = 'white', maxTime = 30 }) {
  // Convert remainingTime (in seconds) to MM:SS format
  const formatTime = (seconds) => {
    // Force to number and fallback to 0 if NaN
    let s = Number(seconds);
    if (isNaN(s)) s = 0;
    
    const totalSeconds = Math.max(0, Math.floor(s));
    const mins = String(Math.floor(totalSeconds / 60)).padStart(2, '0');
    const secs = String(totalSeconds % 60).padStart(2, '0');
    return `${mins}:${secs}`;
  };

  return (
    <div
      className="timer"
      style={{
        color: color,
        fontSize: '24px',
        marginTop: '10px',
        fontWeight: 'bold',
        textAlign: 'center', // Ensure text is centered
      }}
      aria-label={`Remaining recording time: ${formatTime(remainingTime)}`}
    >
      {formatTime(remainingTime)}
    </div>
  );
}

TimerDisplay.propTypes = {
  remainingTime: PropTypes.number,
  color: PropTypes.string,
  maxTime: PropTypes.number, // To calculate percentage if needed
};

export default TimerDisplay;